import React, { useEffect, useState } from 'react';
import "./ServicesSettingsItem.scss"

import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setSettingsAction } from '../../../store/settingsReducer';
import { setServicesAction } from '../../../store/servicesReducer';
import ServicesSettingsItemDetail from '../ServicesSettingsItemDetail/ServicesSettingsItemDetail';

const ServicesSettingsItem = ({ element }) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.settings)
    const services = useSelector(state => state.services.services)
    const clinic = useSelector(state => state.recordsTable.clinic)

    const [sevicesList, setSevicesList] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
		if(!services || services.length === 0){
			fetchServices();
		}
    }, [services])

    useEffect(() => {
        if(element.services_disabled && services){
            let servList = [];
            for(let i = 0; i <= element.services_disabled.length; i++){
                let item = element.services_disabled[i];
                let serv = services.find((el) => Number(item) === Number(el.id))
                if(serv) servList.push(serv)
            }
            if(servList.length > 0){
                setSevicesList(servList)
            }
        }
    }, [element, services])

	const [fetchSettings] = useFetching(async (clinicId) => {
		const response = await PostService.getSettingsByClinic(clinicId)
		if (response.data.success && response.data.result !== false) {
			dispatch(setSettingsAction(response.data.result))
		}
	})

    const [fetchServices] = useFetching(async () => {
		const response = await PostService.getServices()
		if (response.data.success && response.data.result !== false) {
			dispatch(setServicesAction(response.data.result))
		}
	})

	return (
        <>
        <div className="services-settings-list-item" onClick={() => setOpen(true)}>
            {element.rule}
            <div className="services-settings-list-item__services">
                Недоступные услуги:&nbsp;
                {
                    sevicesList && sevicesList.map((el, index) => {
                        return(
                            <span>{index > 0 ? ', ' : ''}{el.short_title}</span>
                        )
                    })
                }
            </div>
        </div>
        <div className="services-settings-list-item__detail">
            <ServicesSettingsItemDetail element={element} closeHandler={() => setOpen(false)} isOpen={open}/>
        </div>
        </>
	);
};

export default ServicesSettingsItem;
